import { render, staticRenderFns } from "./LabelReleaseReadOnly.vue?vue&type=template&id=03adae70"
import script from "./LabelReleaseReadOnly.vue?vue&type=script&lang=js"
export * from "./LabelReleaseReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports